import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./smsControl.css";
import MobileNav from "../../components/mobileNav/MobileNav";

const SmsControl = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [editedDescription, setEditedDescription] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await axios.get(
          "https://api.generalhome.sa/api/SMSTemplates"
        );
        setTemplates(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  const handleEdit = (template) => {
    setCurrentTemplate(template);
    setEditedDescription(template.Description);
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    if (!editedDescription.trim()) {
      Swal.fire({
        title: "خطأ",
        text: "الرجاء إدخال وصف صحيح للرسالة",
        icon: "error",
        confirmButtonText: "حسناً",
      });
      return;
    }

    setIsSaving(true);

    try {
      const updatedData = {
        Id: currentTemplate.Id,
        Description: editedDescription,
        Endpoint: currentTemplate.Endpoint,
      };
      const updatedTemplates = templates.map((template) =>
        template.Id === currentTemplate.Id
          ? { ...template, Description: editedDescription }
          : template
      );
      setTemplates(updatedTemplates);
      const response = await axios.put(
        `https://api.generalhome.sa/api/SMSTemplates/${currentTemplate.Id}`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        await Swal.fire({
          title: "تم!",
          text: "تم تحديث القالب بنجاح",
          icon: "success",
          confirmButtonText: "حسناً",
        });
        setIsModalOpen(false);
      } else {
        throw new Error("Failed to update template");
      }
    } catch (error) {
      setTemplates(templates);
      await Swal.fire({
        title: "خطأ!",
        text: "حدث خطأ أثناء حفظ التغييرات. يرجى المحاولة مرة أخرى.",
        icon: "error",
        confirmButtonText: "حسناً",
      });
      // console.error("Error submitting data:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  if (loading) {
    return <div>Loading SMS templates...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <MobileNav />
      <div className="sms-control-container">
        <h1>تعديل نص الرسائل</h1>
        <table className="sms-templates-table">
          <thead>
            <tr>
              <th>الوصف</th>
              <th>التحكم</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((template) => (
              <tr key={template.Id}>
                <td>{template.Description}</td>
                <td>
                  <button
                    onClick={() => handleEdit(template)}
                    className="edit-button"
                  >
                    تعديل
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Edit Modal/Popup */}
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2>تعديل القالب</h2>
              <div className="form-group">
                <label>Endpoint:</label>
                <input type="text" value={currentTemplate.Endpoint} disabled />
              </div>
              <div className="form-group">
                <label>الوصف:</label>
                <textarea
                  value={editedDescription}
                  onChange={(e) => setEditedDescription(e.target.value)}
                  rows={5}
                />
              </div>
              <div className="modal-actions">
                <button
                  onClick={handleSave}
                  className="save-button"
                  disabled={isSaving}
                >
                  {isSaving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      جاري الحفظ...
                    </>
                  ) : (
                    "حفظ"
                  )}
                </button>
                <button
                  onClick={handleClose}
                  className="cancel-button"
                  disabled={isSaving}
                >
                  إلغاء
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SmsControl;
